<div
  class="tooltip-wrapper-div toolTip-disabled"
  [ngClass]="{
    'full-width': fullWidth === true,
    'full-height': fullHeight === true
  }"
  [nbTooltip]="
    (disabledForSaaS &&
      featureFlagService?.isSaaSCP &&
      SAAS_ONLY_FEATURE_TOOL_TIP) ||
    (userAuthoritiesService.isActionDisabled(action, clusterId, actionsList) &&
      userAuthoritiesService.buttonDisabledTooltip) ||
    toolTip
  "
  [nbTooltipDisabled]="
    !userAuthoritiesService.isActionDisabled(action, clusterId) &&
    !toolTip &&
    !(disabledForSaaS && featureFlagService?.isSaaSCP)
  "
>
  <button
    nbButton
    id="{{ id }}"
    [size]="size"
    [status]="status"
    [disabled]="
      disabled ||
      userAuthoritiesService.isActionDisabled(action, clusterId, actionsList) ||
      (disabledForSaaS && featureFlagService?.isSaaSCP)
    "
    (click)="emitOnClickEvent()"
    [appearance]="appearance"
    [fullWidth]="fullWidth"
    [ngClass]="{
      'p-2 rbac-icon-only-button': label === '' || !label
    }"
    class="{{ label }} {{
      !userAuthoritiesService.isActionDisabled(action, clusterId, actionsList)
        ? setClass
        : ''
    }}"
    [nbSpinner]="loading"
    [attr.data-action-id]="dataAttrActionId"
  >
    <img
      *ngIf="showImgFromUrl && !icon"
      [src]="imgUrl"
      class="{{ iconClass }}"
    />
    <nb-icon
      *ngIf="icon && !showImgFromUrl"
      class="{{ iconClass }} d-flex align-items-center"
      [icon]="icon"
      [ngClass]="{
        'disabled-color': disabled && (label === '' || !label),
        'icon-disabled': userAuthoritiesService.isActionDisabled(
          action,
          clusterId,
          actionsList
        ),
        'rbac-icon-only-button': label === '' || !label
      }"
      [pack]="isFciPack ? 'fci' : 'eva'"
      [ngStyle]="{ 'font-size': isFciPack ? fciIconFontSize : '' }"
      [status]="iconStatus"
    ></nb-icon>
    {{ label }}
  </button>
</div>
